// import { classNames } from 'classnames';
import { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { ActionOverlayPopover, DragDropV2Icon, Layout, TrashIcon } from '@utilities';

import styles from './_index.module.scss';

const SubQuestion = ({ children, index, onDelete }) => {
  const [isDropdownActive, setIsDropdownActive] = useState(false);
  const optionsDropdown = useRef(null);

  return (
    <Layout.Flex className={styles['sub-question']} gap="small">
      <div className={styles['sub-question-icons']}>
        <DragDropV2Icon />
        <strong>{index + 1}</strong>
      </div>

      <Layout.Fill>{children}</Layout.Fill>

      <div className={styles['sub-question-controls']}>
        <ActionOverlayPopover
          hasArrow={false}
          isActive={isDropdownActive}
          onClick={() => setIsDropdownActive(!isDropdownActive)}
          onHide={() => setIsDropdownActive(false)}
          target={optionsDropdown.current}
        >
          <ul>
            <li>
              <button
                aria-label="Delete answer"
                onClick={() => {
                  onDelete();
                  setIsDropdownActive(false);
                }}
              >
                <TrashIcon />
                <span>Delete</span>
              </button>
            </li>
          </ul>
        </ActionOverlayPopover>
      </div>
    </Layout.Flex>
  );
};

SubQuestion.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  onDelete: PropTypes.func.isRequired,
};

export default SubQuestion;
